import React from 'react';
import { LocalizedStandardDate } from 'intl/LocalizedComponents';
import { compose } from 'redux';
import { connect } from 'react-redux';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _has from 'lodash/has';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// Permissions
import permissions from 'constants/Permissions';
import OnlyWith from 'components/permissions/OnlyWith';
// Models
import mDevice from 'models/device';
// Custom
import { deviceDataShape, deleteShape } from 'constants/PropTypesShapes';
import RowDetailsTemplate from 'components/templates/RowDetailsTemplate';
import {
  AddTextButton, EditTextButton, ReplaceTextButton, DeleteTextButton,
} from 'components/buttons/TextButtons';
import {
  LastComDateItem, InstallationDateItem, NetworkLevelItem, NetworkOperatorItem,
} from 'components/items/InformationItems';
import { computeErrors } from 'utils/Forms';
import DeviceStatusItem from 'devices/assets/main/DeviceStatusItem';
import DeviceAsyncStatusItem from 'devices/assets/main/DeviceAsyncStatusItem';
import { configurationDevicesReplacePath, configurationDeviceSlavesAddPath } from 'installations/navigation';
import withEntitiesInformation from 'installations/assets/hocs/WithEntitiesInformation';
import SimcardInformationItem from 'simcards/assets/main/SimcardInformationItem';
import withDeviceData from 'appAssets/hocs/WithDeviceData';
import withScrollerManagement from 'hocs/WithScrollerManagement';
import SlaveItem from './SlaveItem';

class DeviceRowDetails extends React.Component {
  constructor(props) {
    super(props);

    // Create a reference for this item
    const { device } = this.props;
    this.ref = `device_${device.id}`;
  }

  componentDidUpdate(prevProps) {
    const { deviceSlaveDelete, deviceData } = this.props;
    const { deviceSlaveDelete: prevDeviceSlaveDelete } = prevProps;

    // Errors caching
    if (!prevDeviceSlaveDelete.error && deviceSlaveDelete.error && deviceSlaveDelete.idDevice === deviceData.id) {
      // Scroll to error displayer
      const { handleScrollTo } = this.props;
      handleScrollTo(this.ref, 'errorDisplayer');
    }
  }

  render() {
    const {
      device, deviceData, id, onEdit, onDelete, onDeleteSlave, deviceSlaveDelete,
    } = this.props;

    const errors = computeErrors(null, deviceSlaveDelete.error);
    const operationErrors = errors ? { errors, deviceId: deviceSlaveDelete.idDevice } : null;

    // Permissions
    const { pInstallation: { configWrite } } = permissions;

    if (deviceData) {
      const { installation: { device: deviceInstallation }, simcard, device_slaves: deviceSlaves } = deviceData;
      // Sort slaves
      const deviceSlavesArray = mDevice.sortSlaves(deviceSlaves);

      return (
        <RowDetailsTemplate
          errors={operationErrors && operationErrors.deviceId === deviceData.id ? operationErrors.errors : null}
          errorDisplayerRef={this.ref}
          buttons={[
            <OnlyWith
              key="bButs"
              permissions={{
                needed: configWrite,
                permissionsOrContext: 'installationPermissions',
              }}
            >
              <React.Fragment>
                <EditTextButton primary onClick={() => onEdit(deviceData)} />
                <ReplaceTextButton primary path={configurationDevicesReplacePath(id, device.id)} />
                <DeleteTextButton primary onClick={() => onDelete(deviceData)} />
                <AddTextButton primary labelId="button.deviceSlave" path={configurationDeviceSlavesAddPath(id, device.id)} />
              </React.Fragment>
            </OnlyWith>,
          ]}
        >
          <div className="row px-3 information-item-wrapper">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <InstallationDateItem
                value={
                  _has(deviceInstallation, 'since') ? <LocalizedStandardDate value={deviceInstallation.since} /> : null
                }
              />
            </div>
          </div>
          <div className="row px-3">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <DeviceStatusItem device={deviceData} />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <DeviceAsyncStatusItem device={deviceData} />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <LastComDateItem
                value={deviceData.last_comm_date ? <LocalizedStandardDate value={deviceData.last_comm_date} /> : null}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <NetworkOperatorItem networkOperator={_get(deviceData, 'info.network_operator')} />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <NetworkLevelItem
                networkLevel={_get(deviceData, 'info.network_level')}
                networkAccessTechnology={_get(deviceData, 'info.network_access_technology')}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <SimcardInformationItem simcard={simcard} />
            </div>
          </div>
          <div className="px-3 pt-3">
            <div className="row">
              {!!deviceSlavesArray
                && _map(deviceSlavesArray, (deviceSlave) => (
                  <div key={_toString(deviceSlave.id)} className="col-12 pb-3">
                    <SlaveItem
                      id={id}
                      deviceId={device.id}
                      deviceSlave={deviceSlave}
                      onDelete={(value) => onDeleteSlave(deviceData, value)}
                    />
                  </div>
                ))}
            </div>
          </div>
        </RowDetailsTemplate>
      );
    }
    return null;
  }
}

DeviceRowDetails.propTypes = {
  device: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  deviceData: deviceDataShape,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onDeleteSlave: PropTypes.func.isRequired,
  handleScrollTo: PropTypes.func.isRequired,
  deviceSlaveDelete: deleteShape.isRequired,
};

DeviceRowDetails.defaultProps = {
  deviceData: null,
};

const mapStateToProps = (state) => ({
  deviceSlaveDelete: state.installationDeviceSlave.delete,
});

module.exports = compose(
  connect(
    mapStateToProps,
  ),
  withDeviceData('device.id'),
  withScrollerManagement,
  withEntitiesInformation,
)(DeviceRowDetails);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/configuration/DeviceRowDetails.js